<template>

  <div></div>
  
  <!-- 
  ---  Find an other solution for this card. maybe the one they provide bellow
  ---  https://github.com/initialstate/wunderground-sensehat/wiki/Part-1.-How-to-Use-the-Wunderground-API 
  -->
  

  <!-- <div class="feedItem panel bg-lightest black">
    <div class="w-100 d-flex flex-row font-weight-600">
        <div class="w-50">
          <span class="ml-1">{{weatherLabel}} - {{windLabel}}</span>
        </div>
        <div class="w-50 ml-5">
          <span class="border-dark bg-light py-1 niceRadius pointer" @click="toggleView">
            <span class="py-1 px-3" :class="{'bg-dark niceRadius lightest': selectedView == 'overview'}">Overview</span>
            <span class="py-1 px-3" :class="{'bg-dark niceRadius lightest': selectedView == 'details'}">Details</span>
          </span>
        </div>
    </div>
    <div class="px-4 py-5 d-flex h-100">
      <div class="w-50">
        <div class="">
          <img class="align-middle" :src="weatherIcon">
          <span class="temperatureDegrees align-middle font-weight-600">{{temperature/*cardInfo.overview.temperature*/}}º</span>
        </div>
      </div>
      <div class="w-50 ml-5 darker">
        <div><span class="font-weight-600">Percipitation: </span> <span>{{precipitation}}mm</span></div>
        <div><span class="font-weight-600">Humidity: </span> <span>{{humidity}}%</span></div>
        <div><span class="font-weight-600">Wind: </span> <span>{{windSpeed}}km/h</span></div>
        <div><span class="font-weight-600">Location: </span> <span>{{location}}</span></div>
        <div><span class="font-weight-600">Last update: </span> <span>{{lastUpdate}}</span></div>
      </div>
    </div>
    <div class="px-0 pt-5 d-flex windyContainer" v-if="selectedView == 'details'">
      <iframe class="w-100 border-0" src="https://embed.windy.com/embed2.html?lat=37.0902&lon=-8.2508&type=forecast&metricWind=kt&metricTemp=%C2%B0C"></iframe>
    </div>
  </div> -->

</template>

<script>

export default {
  // created: function(){
  //   this.getWeatherInformation();
  // },
  // data: function() {
  //   return{
  //     weatherLabel: 'Weather',
  //     windLabel: 'Wind',
  //     selectedView: 'overview',
  //     weatherIcon: 'static/images/dashboard/weather_sunny.png',
  //     temperature: 28,
  //     precipitation: 0,
  //     humidity: 29,
  //     windSpeed: 10,
  //     location: 'Lisbon',
  //     lastUpdate: '5 minutes ago'
  //   }
  // },
  // methods:{
  //   toggleView: function() {
  //     if(this.selectedView == 'overview'){
  //       this.selectedView = 'details'
  //     } else{
  //       this.selectedView = 'overview'
  //     }
  //   },
  //   getWeatherInformation: function(){

  //     // weather now
  //     var vm = this;
  //     var invocation = new XMLHttpRequest();
  //     /**
  //      * May 15, 2018, Wunderground and IBM have stopped providing free API keys.
  //      * https://github.com/initialstate/wunderground-sensehat/wiki/Part-1.-How-to-Use-the-Wunderground-API
  //      */
  //     var url = null;//'https://api.wunderground.com/api/c1e31519542c609b/conditions/q/PT/Albufeira.json';
  //     var response = null;

  //     invocation.onreadystatechange = function() {
  //       if (this.readyState == 4 && this.status == 200){
  //         response = JSON.parse(this.responseText);
  //         vm.weatherLabel = response.current_observation.weather;
  //         vm.windLabel = response.current_observation.wind_string;
  //         vm.weatherIcon = response.current_observation.icon_url;
  //         vm.temperature = response.current_observation.temp_c;
  //         vm.precipitation = response.current_observation.precip_today_metric;
  //         vm.windSpeed = response.current_observation.wind_kph;
  //         vm.location = response.current_observation.display_location.city;
  //         vm.lastUpdate = moment.unix(response.current_observation.observation_epoch).format('HH:mm');

  //       }
  //     };
  //     invocation.open('GET', url, true);
  //     invocation.send();


  //     // weather forecast
  //     invocation = new XMLHttpRequest();
  //     /**
  //      * May 15, 2018, Wunderground and IBM have stopped providing free API keys.
  //      * https://github.com/initialstate/wunderground-sensehat/wiki/Part-1.-How-to-Use-the-Wunderground-API
  //      */
  //     url = null;//'https://api.wunderground.com/api/c1e31519542c609b/forecast/q/PT/Albufeira.json';
  //     response = null;

  //     invocation.onreadystatechange = function() {
  //       if (this.readyState == 4 && this.status == 200){
  //         response = JSON.parse(this.responseText);
  //         //console.log(response);
  //         vm.humidity = response.forecast.simpleforecast.forecastday[0].avehumidity;
  //       }
  //     };
  //     invocation.open('GET', url, true);
  //     invocation.send();


  //   }
  // },
  // props: {
  //   cardInfo: {
  //     type: Object
  //   }
  // }
}

</script>

<style scoped lang="scss">
  @import '../../assets/scss/_variables.scss';

  .feed .feedItem{
    height: auto; 
    display: none;
  }

  .niceRadius{
    border-radius: 5000px;
  }

  .temperatureDegrees{
    font-size: 2.9rem;
  }

  .windyContainer{
    height: 250px;
  }

</style>



// WEBPACK FOOTER //
// FeedcardWeather.vue?3b9a59c3